import { Input } from "@/components/ui/input";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { usePaperMetadata } from "@/stores/appStore";
import { cn } from "@/lib/utils";
import { HelpCircleIcon } from "@/components/fun-ui/icons/HelpCircleIcon";
import { Tip } from "@/components/fun-ui/Tip";

interface DoiInputProps {
  id?: string;
  value: string;
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength: number;
}

export const DoiInput = ({
  id,
  value,
  onChange,
  placeholder = '',
  disabled = false,
  maxLength = 1000,
}: DoiInputProps) => {
  const {
    fetchPaperMetadataLoading,
    currentPaperMetadataByDoiError,
    fetchPaperMetadataByDoi,
  } = usePaperMetadata();
  const [canFetchPaperMetadata, setCanFetchPaperMetadata] = useState(true);

  useEffect(() => {
    setCanFetchPaperMetadata(true);
  }, [value]);

  const handleTry = useCallback(async () => {
    if (value && canFetchPaperMetadata) {
      setCanFetchPaperMetadata(false);
      await fetchPaperMetadataByDoi({
        doi: value,
      });
    }
  }, [value, canFetchPaperMetadata, setCanFetchPaperMetadata, fetchPaperMetadataByDoi]);
  const handleRetry = useCallback(async () => {
    if (value) {
      setCanFetchPaperMetadata(false);
      await fetchPaperMetadataByDoi({
        doi: value,
      });
    }
  }, [value, setCanFetchPaperMetadata, fetchPaperMetadataByDoi]);

  return (
    <div className="relative">
      <Input
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      <div className="absolute right-0 top-0 bottom-0 flex flex-col items-center">
        <div
          className={
            cn(
              "text-sm font-normal text-annotation-foreground h-10 px-4 py-2.5 select-none ",
              (value && canFetchPaperMetadata) && "text-primary hover:underline underline-offset-2 cursor-pointer",
            )
          }
          onClick={handleTry}
        >
          {
            (canFetchPaperMetadata) ? (
              <span>获取数据</span>
            ) : (
              fetchPaperMetadataLoading ? (
                <span>数据获取中，请稍候</span>
              ) : (
                currentPaperMetadataByDoiError ? (
                  <span className="flex flex-row items-center w-fit">
                    <Tip
                      className="cursor-help text-annotation-foreground"
                      side="top"
                      label={currentPaperMetadataByDoiError}
                    >
                      <HelpCircleIcon />
                    </Tip>
                    <span className="ml-1">获取失败，</span>
                    <span
                      className="text-primary hover:underline underline-offset-2 cursor-pointer"
                      onClick={handleRetry}
                    >请重试</span>
                  </span>
                ) : (
                  <span>已获取数据，请确认后保存</span>
                )
              )
            )
          }
        </div>
      </div>
    </div>
  )
}